import { Show, splitProps } from "solid-js";
import type { JSX } from "solid-js";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "destructive" | "link";
export type ButtonSize = "sm" | "md" | "lg";

interface Props extends Omit<JSX.ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
    variant?: ButtonVariant;
    size?: ButtonSize;
    loading?: boolean;
    fullWidth?: boolean;
    type?: "button" | "submit" | "reset";
}

export function Button(props: Props) {
    const [own, rest] = splitProps(props, [
        "variant",
        "size",
        "loading",
        "fullWidth",
        "class",
        "children",
        "disabled",
    ]);
    const variant = () => own.variant ?? "primary";
    const size = () => own.size ?? "md";
    const cls = () =>
        [
            "btn",
            `btn-${variant()}`,
            `btn-${size()}`,
            own.fullWidth ? "btn-full" : "",
            own.loading ? "btn-loading" : "",
            own.class ?? "",
        ]
            .filter(Boolean)
            .join(" ");

    return (
        <button
            {...rest}
            class={cls()}
            disabled={own.disabled || own.loading}
            aria-busy={own.loading || undefined}
        >
            <Show when={own.loading}>
                <span class="btn-spinner" aria-hidden="true" />
            </Show>
            <span class="btn-label">{own.children}</span>
        </button>
    );
}
